import Vue from "vue";
import VueRouter from "vue-router";
// import Cotizaciones from ''
// import Propuestas from
Vue.use(VueRouter);

// const ifNotAuthenticated = (to, from, next) => {
//   if (!sessionStorage.getItem('token')) {
//     next()
//     return
//   }
//   next('/')
// }

const ifAuthenticated = (to, from, next) => {
  if (sessionStorage.getItem("token")) {
    next();
    return;
  }
  next("/");
};

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/components/Home.vue"),
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "/",
        name: "cotizaciones",
        component: () => import("@/views/Cotizaciones.vue"),
      },
      {
        path: "/propuestas",
        name: "propuestas",
        component: () => import("@/views/Propuestas.vue"),
      },
      {
        path: "/emision",
        name: "companiaEmision",
        component: () => import("@/views/EmisionCompania.vue"),
      },
      {
        path: "/bitacora",
        name: "bitacora",
        component: () => import("@/views/Bitacora.vue"),
      },
      {
        path: "/usuarios",
        name: "usuarios",
        component: () => import("@/views/Users.vue"),
      },
    ],
  },
  //
  // {
  //   path: '/propuestas',
  //   name: 'propuestas',
  //   component: Propuestas
  // },
  // {
  //   //path: '/compania/emision',
  //   path: '/emision',
  //   name: 'companiaEmision',
  //   component: () => import('../views/EmisionCompania.vue')
  // },
  // {
  //   path: '/compania/polizas',
  //   name: 'polizas',
  //   component: () => import('../views/Polizas.vue')
  // },
  //  {
  //   path: '/bitacora',
  //   name: 'bitacora',
  //   component: () => import('../views/Bitacora.vue')
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
